import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'
// import constant from '@constants/constant'
import messageProcessor from './messageProcessor'
import { hmdaACL } from '@utils/accesslevels'

// this module is for enabling short-polling mechanism for server notifications - nelvin

let connection = {}

let config = {}

let interval = 0

export default {
  install(Vue, options) {
    console.log('pollling options received', options)

    config.enableNotificationPolling = Boolean(
      parseInt(options.enablePolling || '0')
    )
    config.pollingInterval = Number(options.pollingInterval || '20000')
    config.pollingIntervalLoanDetails = Number(
      options.pollingIntervalLoanDetails || '5000'
    )

    interval = config.pollingInterval

    // todelete
    console.log('Polling Enabled state: ', config.enableNotificationPolling)

    // check if hmda user, and enable or disabled based on business requirements

    store.dispatch('notifications/setSettings', {
      enabled: config.enableNotificationPolling,
    })
    if (!config.enableNotificationPolling) {
      return
    }

    _getNotification()

    console.log('Repeat Short Polling initialzzing')
    repeatPolling()
  },
}

export const state = {
  notifications: [],
  isShowBellBadge: false,
  enableNotification: false,
}

export const getters = {
  notifications: (state) => state.notifications,
  isShowBellBadge: (state) => state.isShowBellBadge,
  enableNotification: (state) => state.enableNotification,
}

export const mutations = {
  SET_BELLICON(state, value) {
    state.isShowBellBadge = value
  },

  SET_NOTIFICATIONS(state, value) {
    state.notifications = value
  },

  SET_SETTINGS(state, value) {
    state.enableNotification = value.enabled
  },
}

export const actions = {
  setSettings({ commit }, value) {
    commit('SET_SETTINGS', value)
  },
  setBellBadge({ commit }, value) {
    commit('SET_BELLICON', value)
  },
  setNotifications({ commit }, msg) {
    let setNotification = 'SET_NOTIFICATIONS'
    let setBell = 'SET_BELLICON'

    if (!msg || !msg.length) {
      console.log('valueless notification')
      commit(setNotification, []) // state.notifications = []
      commit(setBell, false)
    } else {
      msg = msg.map((m) => messageProcessor.parseMessage(m))
      if (state.notifications.length === 0) {
        console.log('first time setting notification')
        // commit(setBell, true)
      } else {
        // console.log('existing notification, processing data')
        let lastLocalId = state.notifications[0].message.notificationId
        if (lastLocalId < msg[0].message.notificationId) {
          // notify a change state
          console.log(
            'a change state is identified, we will notify via bell icon'
          )
          commit(setBell, true)

          let newMessages = []
          for (var i = 0; i < msg.length; i++) {
            if (msg[i].message.notificationId > lastLocalId) {
              newMessages.push(msg[i])
            } else {
              break // stop the loop
            }
          }

          // console.log(
          //   'now this is thhe list of all NEW notifications i received from my last processing',
          //   newMessages
          // )

          newMessages.forEach((nm) => {
            // let parsed = messageProcessor.parseMessage(nm)
            // console.log("parsed", parsed)
            store.dispatch('broadcast/setMessage', nm, { root: true })
          })
        } else {
          // console.log('no change in the notifications detected')
        }
      }
      commit(setNotification, msg)
    }
  },
  getNotification({ commit }, a) {
    console.log('inside vuex action')
    _getNotification()
  },
}

connection = setInterval(repeatPolling, interval)

function repeatPolling() {
  clearInterval(connection)
  // stopPolling()

  // if (config.pollCount > 3) {
  //   console.log('polling 4 times already, stopping polling')
  //   stopPolling()
  // } else {
  if (hmdaACL.isHMDAUser()) {
    console.log('POLLING SERVER.....')
    // console.log('poll count', config.pollCount)
    _getNotification()
    // }
  }

  let currentRoute = window.location.href
  if (currentRoute.includes('/loans/')) {
    interval = config.pollingIntervalLoanDetails
  } else {
    interval = config.pollingInterval
  }

  connection = setInterval(repeatPolling, interval)
}

function stopPolling() {
  clearInterval(connection)
}
function _getNotification() {
  let auth = store.state.auth.currentUser
    ? store.state.auth.currentUser.access_token
    : null
  if (!auth || !config.enableNotificationPolling || !hmdaACL.isHMDAUser()) {
    return
  }

  config.pollCount = (config.pollCount || 0) + 1

  axios
    .get(
      `${appConfig.broadcastRESTAPIEndpoint}${endpoint.broadcast.notification}`,
      {
        headers: setHeaders(),
        validateStatus: (status) => status === 200,
      }
    )
    .then((response) => {
      console.log('notifications retrieved from server', response)

      // faking data here
      // if (config.pollCount > 2) {
      //   console.log('faking data to trigger badge icon')
      //   let array = response.data
      //   array.splice(0, 0, {
      //     createdDate: '2022-12-14T07:38:45.46',
      //     message: 'New Invalid ULI',
      //     notificationId: 75,
      //     projectId: 135,
      //     type: 1,
      //     userId: 1796,
      //   })
      // }

      store.dispatch('notifications/setNotifications', response.data || [], {
        root: true,
      })
      return response
    })
    .catch((err) => {
      console.log('error in notification module', err)
      stopPolling()
    })
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

// function __showError(msg) {
//   store.dispatch(
//     'toaster/setAlert',
//     {
//       title: 'Error',
//       msg: msg || 'An unexpected error occured while processing data (0x33)',
//       variant: constant.AlertTypes.Error,
//     },
//     { root: true }
//   )
// }
